<template>
  <div class="hello grid h100">

  <div class="grid login">
    <div class="data">
      <div class="methods">
        <h1>Benchmark</h1>
      <!-- <img src="../assets/img/logo_2.png"> -->
      <div class="spacer sm"></div>
      <!-- <form method="post" action="http://localhost:44534/login"> -->
      <form method="post" action="https://bench.node.systems:44534/login">
        <!-- You are not logged in! Please <a @click="auth.login()">Log In</a> to continue. -->
        <p><input type="text" class="form-control" name="email" v-model="email" placeholder="Username"></p>
        <p><input type="password" class="form-control" name="password" v-model="password" placeholder="Password"></p>
        <div class="spacer xs"></div>
        <p><button type="submit" class="btn btn-yellow block">login</button></p>
      </form>
        <div class="spacer sm"></div>
      </div>
    </div>
<!--     <div class="pic">
      <h1>Gioca, Vinci e fai donare</h1>
    </div> -->
  </div>

  </div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      email: '',
      password: ''
    }
  }
  // methods: {
  //   login () {
  //   }
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue